module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-faste-tillaeg text-dark"
  }, [_c('h2', {
    staticClass: "marg-1-bottom capitalize"
  }, [_vm._v("Faste tillæg")]), _vm._v(" "), (_vm.isNoConfiguration) ? [_vm._m(0)] : [_c('div', {
    staticClass: "sd-faste-tillaeg__header"
  }, [_c('div', {
    staticClass: "sd-faste-tillaeg__header__left"
  }, [_c('Tabs', {
    attrs: {
      "tabs": _vm.viewTabs,
      "selected": _vm.viewTab
    },
    on: {
      "select": _vm.onSelectViewTab
    }
  }), _vm._v(" "), (_vm.viewTab === 'employments') ? [_c('DoFiltersFilter', {
    attrs: {
      "title": 'Personer',
      "tags": _vm.personNames,
      "selectedTags": _vm.selectedPersonNames,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg personer'
    },
    on: {
      "select": _vm.togglePersonName,
      "clear": function($event) {
        _vm.selectedPersonNames = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Grupper',
      "tags": _vm.userTags,
      "selectedTags": _vm.selectedUserTags,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg grupper'
    },
    on: {
      "select": _vm.toggleUserTag,
      "clear": function($event) {
        _vm.selectedUserTags = []
      }
    }
  }), _vm._v(" "), (_vm.employmentTitles.length > 1) ? _c('DoFiltersFilter', {
    attrs: {
      "title": 'Ansættelser',
      "tags": _vm.employmentTitles,
      "selectedTags": _vm.selectedEmploymentTitles,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg stilling'
    },
    on: {
      "select": _vm.toggleEmploymentTitle,
      "clear": function($event) {
        _vm.selectedEmploymentTitles = []
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.organisations.length > 1) ? _c('DoFiltersFilter', {
    attrs: {
      "title": 'Organisationer',
      "tags": _vm.organisations,
      "selectedTags": _vm.selectedOrganisations,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg organisation'
    },
    on: {
      "select": _vm.toggleOrganisation,
      "clear": function($event) {
        _vm.selectedOrganisations = []
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "sd-faste-tillaeg__count"
  }, [_vm._v("\n            Viser " + _vm._s(_vm.filteredRows.length) + " af " + _vm._s(_vm.allRows.length) + " ansættelser\n          ")])] : [_c('DoFiltersFilter', {
    attrs: {
      "title": 'Personer',
      "tags": _vm.uniqueNames,
      "selectedTags": _vm.selectedNames,
      "numberOfSelectedTagsToShow": 2,
      "placeholder": 'Vælg personer'
    },
    on: {
      "select": _vm.toggleName,
      "clear": function($event) {
        _vm.selectedNames = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Lønkode',
      "tags": _vm.uniqueTillaeg,
      "selectedTags": _vm.selectedTillaeg,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg lønkode'
    },
    on: {
      "select": _vm.toggleTillaeg,
      "clear": function($event) {
        _vm.selectedTillaeg = []
      }
    }
  })]], 2), _vm._v(" "), (_vm.viewTab !== 'employments') ? _c('div', {
    staticClass: "sd-faste-tillaeg__header__right"
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--small",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.readTillaeger
    }
  }, [_vm._v("\n          Opdater\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.viewTab === 'employments') ? _c('div', {
    staticClass: "sd-faste-tillaeg__toolbar"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'top',
        animateFill: false,
        animation: 'shift-away',
        boundary: 'window'
      }),
      expression: "{\n              arrow: true,\n              placement: 'top',\n              animateFill: false,\n              animation: 'shift-away',\n              boundary: 'window'\n            }"
    }],
    staticClass: "sd-faste-tillaeg__toolbar__wrap",
    attrs: {
      "content": _vm.selectedEmploymentIds.length === 0 ? 'Vælg personer først' : ''
    }
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': _vm.selectedEmploymentIds.length === 0
    },
    attrs: {
      "disabled": _vm.selectedEmploymentIds.length === 0
    },
    on: {
      "click": _vm.openBulkCreate
    }
  }, [_vm._v("\n          Opret faste tillæg\n        ")])]), _vm._v(" "), _c('DDropdown', {
    attrs: {
      "isBottomStart": true,
      "isShowDots": false,
      "propOffset": [0, 8]
    }
  }, [_c('button', {
    staticClass: "do-bttn",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n          Beregn tillæg automatisk "), _c('span', {
    staticClass: "icon-arrow-down5"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "beregn-menu",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.visibleBeregnOptions), function(option) {
    return _c('li', {
      key: option.id,
      on: {
        "click": function($event) {
          return _vm.selectBeregnOption(option)
        }
      }
    }, [_vm._v("\n            " + _vm._s(option.label) + "\n          ")])
  }), 0)]), _vm._v(" "), (_vm.selectedEmploymentIds.length > 0) ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.cancelBatchMode
    }
  }, [_vm._v("Annuller valg")]) : _vm._e(), _vm._v(" "), (_vm.selectedEmploymentIds.length > 0) ? _c('span', {
    staticClass: "sd-faste-tillaeg__count"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedEmploymentIds.length) + " valgt\n      ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.viewTab === 'outbox') ? _c('div', {
    staticClass: "sd-faste-tillaeg__info"
  }, [_vm._v("\n      Faste tillæg i udbakken sendes automatisk til SD senere på dagen. Du kan slette dem, så længe de ligger her.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sd-faste-tillaeg__body"
  }, [(_vm.viewTab === 'employments') ? [(_vm.isLoadingEmployments) ? _c('Loader') : _c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "td-check do-table__toggle-all",
    on: {
      "click": _vm.toggleAllSelected
    }
  }, [_c('div', {
    staticClass: "do-checkbox",
    class: {
      'do-checkbox--selected': _vm.isAllFilteredSelected
    }
  })]), _vm._v(" "), _c('th', [_vm._v("NAVN")]), _vm._v(" "), _c('th', [_vm._v("ANSÆTTELSE")]), _vm._v(" "), _c('th', [_vm._v("ORGANISATION")]), _vm._v(" "), _c('th', {
    staticClass: "th-row-actions"
  })])]), _vm._v(" "), (_vm.filteredRows.length === 0) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": 5
    }
  }, [_vm._v("Ingen ansættelser fundet")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.groupedRows), function(group) {
    return _c('tbody', {
      key: group.userId,
      staticClass: "user-group"
    }, _vm._l((group.rows), function(row) {
      return _c('tr', {
        key: row.id,
        staticClass: "fast-tillaeg-row",
        class: {
          'is-selected': _vm.isRowSelected(row)
        },
        on: {
          "click": function($event) {
            return _vm.onRowClick(row)
          }
        }
      }, [_c('td', {
        staticClass: "td-check",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.onCheckboxClick(row)
          }
        }
      }, [_c('div', {
        staticClass: "do-checkbox",
        class: {
          'do-checkbox--selected': _vm.isRowSelected(row)
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "bold"
      }, [_vm._v(_vm._s(row.userName))]), _vm._v(" "), _c('td', {
        staticClass: "td-organisation"
      }, [_vm._v("\n              " + _vm._s(row.employmentNumber) + " - " + _vm._s(row.employmentTitle) + "\n            ")]), _vm._v(" "), _c('td', {
        staticClass: "td-organisation"
      }, [_vm._v(_vm._s(row.organisation))]), _vm._v(" "), _c('td', {
        staticClass: "td-row-actions"
      }, [(!_vm.isBatchMode) ? _c('button', {
        staticClass: "do-bttn do-bttn--small row-action-btn",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.openSingleCreate(row)
          }
        }
      }, [_vm._v("Opret fast tillæg")]) : _vm._e()])])
    }), 0)
  })], 2)] : [(_vm.isLoading) ? _c('Loader') : _c('table', {
    staticClass: "do-table do-table--striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "sortable td-created",
    on: {
      "click": function($event) {
        return _vm.sortEntries('created_at')
      }
    }
  }, [_vm._v("OPRETTET "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable",
    on: {
      "click": function($event) {
        return _vm.sortEntries('user')
      }
    }
  }, [_vm._v("NAVN "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable",
    on: {
      "click": function($event) {
        return _vm.sortEntries('employment')
      }
    }
  }, [_vm._v("ANSÆTTELSE "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable",
    on: {
      "click": function($event) {
        return _vm.sortEntries('tillaeg')
      }
    }
  }, [_vm._v("TILLÆG "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable td-units",
    on: {
      "click": function($event) {
        return _vm.sortEntries('antal')
      }
    }
  }, [_vm._v("ANTAL "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable td-date",
    on: {
      "click": function($event) {
        return _vm.sortEntries('fra')
      }
    }
  }, [_vm._v("FRA "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable td-date",
    on: {
      "click": function($event) {
        return _vm.sortEntries('til')
      }
    }
  }, [_vm._v("TIL "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable td-created-by",
    on: {
      "click": function($event) {
        return _vm.sortEntries('created_by')
      }
    }
  }, [_vm._v("OPRETTET AF "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "sortable td-status",
    on: {
      "click": function($event) {
        return _vm.sortEntries('state')
      }
    }
  }, [_vm._v("STATUS "), _c('span', {
    staticClass: "icon-menu-open sort-icon"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-actions"
  })])]), _vm._v(" "), _c('tbody', [(_vm.displayedPairs.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": 10
    }
  }, [_vm._v("\n              " + _vm._s(_vm.viewTab === 'outbox' ? 'Udbakken er tom' : 'Ingen afsendte faste tillæg') + "\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedPairs), function(pair) {
    return _c('tr', {
      key: pair.vRowKey,
      staticClass: "tillaeg-row"
    }, [_c('td', {
      staticClass: "td-created"
    }, [_vm._v(_vm._s(pair.vCreatedAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pair.vUserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pair.vEmploymentNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pair.vTillaeg))]), _vm._v(" "), _c('td', {
      staticClass: "td-units"
    }, [_vm._v(_vm._s(pair.vEnheder))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(pair.vFraDato))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(pair.vTilDato))]), _vm._v(" "), _c('td', {
      staticClass: "td-created-by"
    }, [_vm._v(_vm._s(pair.vCreatedBy))]), _vm._v(" "), _c('td', {
      staticClass: "td-status"
    }, [_c('span', {
      staticClass: "status-pill",
      class: 'status-pill--' + pair.state
    }, [_vm._v(_vm._s(_vm.stateLabel(pair.state)))])]), _vm._v(" "), _c('td', {
      staticClass: "td-actions"
    }, [(_vm.viewTab === 'outbox' && pair.can_delete) ? _c('button', {
      staticClass: "do-bttn do-bttn--small do-bttn--danger",
      attrs: {
        "disabled": _vm.isDeleting(pair)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deletePair(pair)
        }
      }
    }, [_vm._v("\n                Slet\n              ")]) : _vm._e()])])
  })], 2)])]], 2)], _vm._v(" "), (_vm.createEmploymentIds.length > 0) ? _c('SdCreateFastTillaeg', {
    attrs: {
      "schoolId": _vm.schoolId,
      "employmentIds": _vm.createEmploymentIds,
      "subtitle": _vm.createSubtitle
    },
    on: {
      "created": _vm.onCreated,
      "close": _vm.closeCreate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowTidsbegraenset) ? _c('TidsbegraensetUvModal', {
    on: {
      "created": function($event) {
        _vm.isShowTidsbegraenset = false
      },
      "close": function($event) {
        _vm.isShowTidsbegraenset = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowBeregnModal) ? _c('DModal', {
    staticStyle: {
      "z-index": "12312312312313"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": _vm.closeBeregnModal
    }
  }, [_c('div', {
    staticClass: "beregn-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "beregn-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.beregnModalTitle))]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle beregn-modal__close",
    on: {
      "click": _vm.closeBeregnModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "beregn-modal__content"
  }, [_c('Supplements', {
    attrs: {
      "isInOpusModal": true,
      "beregningType": _vm.beregnType,
      "sendToOpusTrigger": _vm.sendToSdTrigger
    },
    on: {
      "approveState": function($event) {
        _vm.sdApproveState = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.sdApproveState.canApprove) ? _c('div', {
    staticClass: "beregn-modal__footer"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'top',
        animateFill: false,
        animation: 'shift-away',
        boundary: 'window',
        onShow: function () { return _vm.sendToSdTooltip !== ''; }
      }),
      expression: "{\n                arrow: true,\n                placement: 'top',\n                animateFill: false,\n                animation: 'shift-away',\n                boundary: 'window',\n                onShow: () => sendToSdTooltip !== ''\n              }"
    }],
    staticClass: "send-to-sd-wrap",
    attrs: {
      "content": _vm.sendToSdTooltip
    }
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.sdApproveState.isApproving,
      'do-bttn--submit--disabled': _vm.sdApproveState.count === 0 || _vm.sdApproveState.missingEmployment
    },
    attrs: {
      "disabled": _vm.sdApproveState.isApproving || _vm.sdApproveState.count === 0 || _vm.sdApproveState.missingEmployment
    },
    on: {
      "click": _vm.triggerSendToSd
    }
  }, [_vm._v("\n            Send til SD\n          ")])])]) : _vm._e()])]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-faste-tillaeg-no-config"
  }, [_c('h2', [_c('i', [_vm._v("Skolens Silkeborg Data-integration er ikke konfigureret korrekt. Kontakt Docendo for at få hjælp til\n          opsætningen - enten på chat eller email.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4861f947!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/Silkeborgdata/SdFasteTillaeg.vue
// module id = 1897
// module chunks = 1